import React, { Fragment } from "react";
import PageTitle from "../../pagetitle/PageTitle";
import Scrollbar from "../../scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import Services from "../../../api/service";
import icon from "../../../images/icons/icon_check_3.svg";

function ServicesSinglePage() {
  const { slug } = useParams();
  const ServiceDetails = Services.find((item) => item.slug === slug);
  return (
    <Fragment>
      <main className="page_content service-single-page">
        <PageTitle pageTitle={ServiceDetails.title} pageTop={"Services"} />
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <h2 className="details_item_title">{ServiceDetails.title}</h2>
            <p>{ServiceDetails.description}</p>
            {ServiceDetails.approach && (
              <>
                <h3 className="details_item_info_title mt-5">
                  Our Approach to {ServiceDetails.title}
                </h3>
                <div className="row">
                  {ServiceDetails.approach.map((item, index) => (
                    <div className="col-md-12 " key={index}>
                      <h5 className="font-weight-bold">{item.title}</h5>
                      <p className="m-0">{item.description}</p>
                    </div>
                  ))}
                </div>
              </>
            )}

            {ServiceDetails.outcomeIntro && (
              <>
                <h3 className="details_item_info_title mt-5">
                  Service Outcomes
                </h3>
                <p className="mb-4">{ServiceDetails.outcomeIntro}</p>

                <div className="row">
                  {ServiceDetails.outcomeDetails.map((item, index) => (
                    <div className="col-md-6 mb-4" key={index}>
                      <h4 className="font-weight-bold">{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </section>
      </main>
      <Scrollbar />
    </Fragment>
  );
}

export default ServicesSinglePage;
